import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const {
  FAILURE_GET_ALL_COMPETED_DOCUMENT,
  SUCCESS_GET_ALL_COMPETED_DOCUMENT,
  RESET_GET_ALL_COMPETED_DOCUMENT,
  LOADER_GET_ALL_COMPETED_DOCUMENT,
  REQUEST_GET_ALL_COMPETED_DOCUMENT,
} = documentationActions;

function* getAllCompetedDoc(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADER_GET_ALL_COMPETED_DOCUMENT });
    const response = yield call(templateService.getCompetedDocument, action.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_ALL_COMPETED_DOCUMENT, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_ALL_COMPETED_DOCUMENT, payload: error });
  }
}

function* getAllCompetedDocSaga() {
  yield takeEvery(REQUEST_GET_ALL_COMPETED_DOCUMENT, getAllCompetedDoc);
}

export default getAllCompetedDocSaga;
